var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDoorWindow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 39,
    viewBox: "0 0 35 39",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.609375 39C21.45 39 13.2844 39 34.125 39C34.4906 39 34.7344 38.7562 34.7344 38.3906C34.7344 38.025 34.4906 37.7812 34.125 37.7812H29.8594V0.609375C29.8594 0.24375 29.6156 0 29.25 0H5.48438C5.11875 0 4.875 0.24375 4.875 0.609375V37.7812H0.609375C0.24375 37.7812 0 38.025 0 38.3906C0 38.7562 0.24375 39 0.609375 39ZM6.09375 1.21875H28.6406V37.7812H6.09375V1.21875Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2031 3.41211H21.9984H10.5421C10.1765 3.41211 9.93277 3.65586 9.93277 4.02148L9.93274 35.6483C9.93274 36.0139 10.1765 36.2577 10.5421 36.2577H26.2031C26.5687 36.2577 26.8124 36.0139 26.8124 35.6483L26.8125 4.02148C26.8125 3.7168 26.5078 3.41211 26.2031 3.41211ZM15.3562 35.0998L18.6468 4.6918H20.475L17.1843 35.0998H15.3562ZM11.1515 4.63086H16.9406L13.589 35.0998H11.1515L11.1515 4.63086ZM25.5937 35.0998H18.9515L22.2421 4.6918H25.5937L25.5937 35.0998Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04376 17.6719C7.67814 17.6719 7.43439 17.9156 7.43439 18.2812V20.7188C7.43439 21.0844 7.67814 21.3281 8.04376 21.3281C8.40939 21.3281 8.65314 21.0844 8.65314 20.7188V18.2812C8.65314 17.9766 8.40939 17.6719 8.04376 17.6719Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0,
    y1: 0,
    x2: 38.7398,
    y2: 34.5027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 9.93274,
    y1: 3.41211,
    x2: 36.6389,
    y2: 17.1367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 7.43439,
    y1: 17.6719,
    x2: 9.62814,
    y2: 18.4031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB37"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoorWindow);
export default __webpack_public_path__ + "static/media/icon-door-window.6a6473480c62fd4836eb599cf8423f6f.svg";
export { ForwardRef as ReactComponent };